const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Slack settings component
 * @argument {Application} Application injected to gain access to the global Application service
 * @argument {CompanyIntegrations} CompanyIntegrations injected to gain access to the Company Integrations
 */
app.directive('slackSettings', ['Application', 'CompanyIntegrations', 'SlackIntegrate', 'appConfiguration', function (Application, CompanyIntegrations, SlackIntegrate, appConfiguration) {
  return {
    restrict: "E",
    replace: true,
    scope : {
      'modalactive': '=?',
      'type': '@?'
    },
    template: require('../../templates/directives/slack-settings.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      var domain = Application.navigation.getHost();
      var urlParams = Application.navigation.getUrlParameters();
      self.type = 'standard';
      if ($scope.type === 'eddy' || urlParams.type === 'eddy') {
        self.type = 'eddy';
      }

      self.slackLink = self.type === 'standard' ? Application.slackLink : Application.eddySlackLink;

      self.toggleModalActive = function(){
        $scope.modalactive = !$scope.modalactive;
      };

      self.checkParams = function() {
        var params = Application.navigation.getUrlParameters();
        if (params.code) {
          const createReq = self.type === 'standard' ? SlackIntegrate.create : SlackIntegrate.createEddy;

          createReq({}, {
            code: params.code,
            state: domain,
            redirect_uri: self.type === 'standard' ? `https://${domain}/pvt/slack` : `${appConfiguration.apiUrl}/v3/public/slack/eddy-oauth-redirect`
          }, function(data) {
            self.hasSlack = true;
            self.slackNeedsUpdate = false;

            Application.messaging.addMessage({type: 'success', text: 'Slack Configured!', druation: 5});
            // Application.navigation.goTo('/overview/settings', {});
          }, function(err) {
            console.log('error in making slack integration: ', err)
            Application.navigation.goTo('/overview/settings/integrations', {});
          });
        }

      };

      self.uninstall = function() {
        self.uninstalling = true;

        SlackIntegrate.uninstall({}).$promise
        .then(function(results) {
          if (results.status === 'ok') {
            self.hasSlack = false;
            self.slackNeedsUpdate = false;
          }
          self.uninstalling = false;
          self.showUninstall = false;
        }).catch(function(error) {
          console.log('error: ', error);
          self.uninstalling = false;
        });
      };
      
      self.initialize = function () {
        CompanyIntegrations.status({}, function (data) {
          self.companyIntegration = data || {};
          self.hasSlack = self.type === 'eddy' ? self.companyIntegration.eddySlack : self.companyIntegration.slack;
          self.slackNeedsUpdate = self.companyIntegration.slackNeedsUpdate;

          self.checkParams();
        }, function (error) {
          console.log('Error occured getting company integration ', error);
        });

      };
      self.initialize();
    }],
    controllerAs: 'slack'
  }
}]);
